import { 
    GET_PROFILE_NOTIFICATIONS_SUCCESS,
    GET_PROFILE_NOTIFICATIONS_ERROR,
} from '../actions';

const initialState = {
    data: null,
    error: null,
};

function notificationReducer(state = initialState, action) {
    switch(action.type) {
        case GET_PROFILE_NOTIFICATIONS_SUCCESS:
            return Object.assign({}, state, {error: null});
        case GET_PROFILE_NOTIFICATIONS_ERROR:
            return Object.assign({}, state, {error: action.error});
        default:
            return state;
    }
}

export default notificationReducer;